module.exports = __webpack_public_path__ + "c605a3c7042e6f9e2e2f793079592902.png";